import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/reports/reportdialog';

@Component({
  selector: 'app-patient-lab',
  templateUrl: './patient-lab.component.html',
  styleUrls: ['./patient-lab.component.scss']
})
export class PatientLabComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PatientLabComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  ngOnInit(): void {
  }
  
  keyDownFunction(event) {

    if (event.keyCode === 27) {
      this.dialogRef.close();
      }
   
  }
}
